<template>
  <div class="ps-panel">
    <div class="ps-panel-hd">
      <h2>{{ $t('profile.editProfile') }}</h2>
      <p>Nome de exibição e nome de usuário para acesso.</p>
    </div>
    <div class="ps-field-group">
      <div class="input-field">
        <label for="ps-name">{{ $t('profile.displayName') }}</label>
        <input id="ps-name" :value="name" type="text" @input="$emit('update:name', ($event.target as HTMLInputElement).value)" />
      </div>
      <div class="input-field">
        <label for="ps-username">{{ $t('profile.usernameLabel') }}</label>
        <input id="ps-username" :value="username" type="text" @input="$emit('update:username', ($event.target as HTMLInputElement).value)" />
      </div>
    </div>
    <p v-if="error" class="ps-error">{{ error }}</p>
    <div class="ps-panel-ft">
      <button class="btn btn-primary btn-login" type="button" @click="$emit('save')">{{ $t('common.save') }}</button>
      <button class="btn btn-ghost btn-login" type="button" @click="$emit('cancel')">{{ $t('common.cancel') }}</button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ProfileInfoTab',
  props: {
    name: { type: String, required: true },
    username: { type: String, required: true },
    error: { type: String, default: '' },
  },
  emits: ['update:name', 'update:username', 'save', 'cancel'],
})
</script>

<style scoped lang="scss">
.ps-panel-hd { margin-bottom: 24px; h2 { font-size: 18px; font-weight: 700; color: var(--ink); margin: 0 0 4px; } p { font-size: 13px; color: var(--ink-muted); margin: 0; } }
.ps-field-group { display: flex; flex-direction: column; gap: 16px; margin-bottom: 20px; }
.input-field { display: grid; gap: 5px; label { font-size: 13px; font-weight: 600; color: var(--ink-muted); } input { border: 1px solid var(--border-strong); border-radius: var(--radius, 6px); padding: 8px 10px; font-size: 14px; background: var(--surface); color: var(--ink); &:focus { outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px var(--accent-light); } } }
.ps-error { font-size: 13px; color: var(--danger, #a4262c); margin: 0 0 12px; }
.ps-panel-ft { display: flex; gap: 10px; }
.btn { display: inline-flex; align-items: center; justify-content: center; gap: 6px; border: 1px solid transparent; border-radius: var(--radius, 6px); padding: 6px 16px; font-size: 14px; font-weight: 600; cursor: pointer; transition: background .12s; }
.btn-primary { background: var(--system-navbar, #0f4c81); color: var(--system-navbar-text, #fff); &:hover { filter: brightness(1.1); } }
.btn-ghost { background: transparent; color: var(--ink); border-color: var(--border-strong); &:hover { background: var(--surface-3); } }
.btn-login { padding: 10px 22px; border-radius: 8px; }
</style>
